<div class="dialog-container">
  <div class="dialog-header flex_sb">
    <div class="dialog-header-title fw-700">{{ coupon }}</div>
    <div class="dialog-header-cross" (click)="cancelClicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <div class="dialog-body">
    <div class="rest-list-container p-r-4">
      <ng-container *ngFor="let rest of restList">
        <div class="rest-item flex_sb">
          <div class="logo">
            <img [src]="images.CROSS" class="img-20" alt="close" />
          </div>
          <div class="flex-1 fs-16 fw-700">
            {{ rest?.name }}
            <div *ngIf="rest?.applied_coupon" class="fs-12 fw-400">
              You've already applied {{ rest?.applied_coupon }} for this
              restaurant, want to replace it?
            </div>
          </div>
          <div>
            <nz-tag
              class="m-t-10 ml-10 border-r"
              *ngIf="rest?.amount_saved"
              [nzColor]="'green'"
              >Saved RM {{ rest?.amount_saved }} </nz-tag
            >
          </div>
          <!-- <div>
            <label
              nz-checkbox
              [(ngModel)]="rest.checked"
              (ngModelChange)="updateAllOrderType($event)"
              [ngModelOptions]="{ standalone: true }"
            ></label>
          </div> -->
        </div>
      </ng-container>
    </div>
    <!-- <button
      class="map-btn m-t-16"
      [ngClass]="{ 'disable-action': !selectedRestaurant }"
    >
      {{ 'Apply to All' | fallbackTranslate }}
    </button> -->
  </div>
</div>
